<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="PaySetting" toName="支付宝支付" goPathName="支付设置"></Breadcrumb>
    <a-form-model ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :model="ruleForm" :rules="rules"
                  style="margin-top: 30px">
      <a-form-model-item label="支付状态" :required="true">
        <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.paymentStatus"/>
      </a-form-model-item>
      <div v-if="isShowInfo">
        <a-form-model-item label="自有支付" :required="true">
          <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.paymentOwn" :disabled="isAct"/>
        </a-form-model-item>
        <a-form-model-item label="支付宝应用ID" prop="aliPayAppId">
          <a-input
            style="width: 320px"
            placeholder=" 请输入"
            v-model="ruleForm.aliPayAppId"
          />
          <a-tooltip placement="topLeft" style="margin-left: 15px">
            <template slot="title">
              <span>支付宝开放平台-->创建应用-->网页&移动应用-->获取AppID</span>
            </template>
            <a-icon type="info-circle"/>
          </a-tooltip>
        </a-form-model-item>
        <a-form-model-item label="支付宝应用私钥" prop="aliPayAppPrivateKey">
          <a-input
            style="width: 320px"
            placeholder=" 请输入"
            v-model="ruleForm.aliPayAppPrivateKey"
          />
        </a-form-model-item>
        <a-form-model-item label="支付宝应用公钥" prop="aliPayAppPublicKey">
          <a-input
            placeholder=" 请输入"
            style="width: 320px"
            v-model="ruleForm.aliPayAppPublicKey"
          />
        </a-form-model-item>
        <a-form-model-item label="IP白名单" prop="aliPayIpWhitelist">
          <a-input
            placeholder=" 请输入"
            style="width: 320px"
            v-model="ruleForm.aliPayIpWhitelist"
            disabled
          />
        </a-form-model-item>
        <a-form-model-item label="授权回调地址" prop="aliPayOwnNotifyUrl">
          <a-input
            placeholder=" 请输入"
            style="width: 320px"
            v-model="ruleForm.aliPayOwnNotifyUrl"
            disabled
          />
        </a-form-model-item>

        <a-form-model-item label="管理人手机号">
          <a-input
            placeholder=" 请输入"
            style="width: 320px"
            :value="getShowMobile(mobileShow)"
            disabled
          />
        </a-form-model-item>
        <a-form-model-item label="图形验证码" prop="verificationImg">
          <div style="width: 320px;clear: both">
            <a-input
              style="width: 180px"
              v-model="ruleForm.verificationImg"
              :maxLength="4"
              placeholder="请输入">
            </a-input>
            <img style="width:130px;height:31px;float: right" :src="imageCodeUrl" alt="验证码" class="img-code"
                 @click="restImageCodeUrl()">
          </div>
        </a-form-model-item>

        <a-form-model-item label="安全验证码" prop="verificationCode">
          <a-input
            placeholder="请输入"
            style="width: 180px"
            v-model="ruleForm.verificationCode"
            :maxLength="6"
          />
          <a-button v-if="second<=0" style="margin-left:10px;width:130px;" @click="getSmsCode()">获取验证码</a-button>
          <a-button v-else style="margin-left: 10px;width:130px;">{{ second }}秒后重新发送</a-button>
        </a-form-model-item>
      </div>
      <a-form-model-item label=" " :colon="false" :required="false">
        <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
        <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import formMixin from '../../utils/mixins/formMixins'
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import countDownHelper from '../../utils/helper/countDownHelper'

export default {
  name: 'ZfbPaySetting',
  mixins: [formMixin],
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 12 },
      ruleForm: {
        paymentStatus: false,//支付状态
        paymentOwn: false,//自我支付
        aliPayAppId: '',//支付宝AppId ,
        aliPayAppPrivateKey: '', //私钥 ,
        aliPayAppPublicKey: '',// 公钥 ,
        aliPayIpWhitelist: '',// IP白名单 ,
        aliPayOwnNotifyUrl: '',// 独立支付授权回调地址
        verificationImg: '',//图形验证码
        verificationCode: ''//安全验证码
      },
      rules: {
        aliPayAppId: [
          { required: true, message: '请输入支付宝应用ID', trigger: 'blur' }
        ],
        aliPayAppPrivateKey: [
          { required: true, message: '请输入支付宝应用私钥', trigger: 'blur' }
        ],
        aliPayAppPublicKey: [
          { required: true, message: '请输入支付宝应用公钥', trigger: 'blur' }
        ],
        verificationImg: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入安全验证码', trigger: 'blur' }
        ]
      },
      second: 0,
      imageCodeUrl: '',
      randomNum: '',
      WxSetInfo: '',
      mobileShow: '',
      isAct: false, //true不可操作
      isShowInfo: false
    }
  },
  mounted() {  //重置  this.$refs.ruleForm.resetFields();
    this.restImageCodeUrl()
    this.getPayState()
    this.getMpbile()
    this.getAliAuthorize()
    this.getOwn()
  },
  activated() {

  },
  methods: {
    getOwn() {
      this.getHttpServices().getUserService().post('api/v2/paySetUp/query/own')
        .then(res => {
          this.isShowInfo = res.ownSwitch
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPayState() {
      let params = {
        paymentMerchantId: this.$store.getters.userInfo.merchantId,
        paymentType: 1
      }
      this.getHttpServices().getUserService().post('/api/v2/paySetUp/query/details', params)
        .then(res => {
          this.WxSetInfo = res
          this.ruleForm.aliPayAppId = res.paymentAliVo.aliPayAppId
          this.ruleForm.aliPayAppPrivateKey = res.paymentAliVo.aliPayAppPrivateKey
          this.ruleForm.aliPayAppPublicKey = res.paymentAliVo.aliPayAppPublicKey
          this.ruleForm.paymentStatus = res.paymentStatus == 1 ? true : false//支付状态
          this.ruleForm.paymentOwn = res.paymentOwn == 1 ? true : false//自我支付
          this.isAct = res.paymentOwn == 1 ? true : false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getAliAuthorize() {
      this.getHttpServices().getUserService().post('api/v2/paySetUp/aliAuthorize')
        .then(res => {
          this.ruleForm.aliPayIpWhitelist = res.aliPayIpWhitelist
          this.ruleForm.aliPayOwnNotifyUrl = res.aliPayOwnNotifyUrl
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getMpbile() {
      this.getHttpServices().getUserService().post('/api/v2/paySetUp/query/mobile', {})
        .then(res => {
          this.ruleForm.mobile = res
          this.mobileShow = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getShowMobile(mobile) {
      if (mobile && mobile.length > 3) {
        return mobile.substr(0, 3) + '****' + mobile.substr(mobile.length - 4)
      }
      return mobile
    },

    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    },
    getSmsCode() {
      const verificationImg = this.ruleForm.verificationImg
      if (verificationImg && (typeof verificationImg === 'string' || typeof verificationImg === 'number')) {
        const params = {
          effect: 7,
          mobile: this.ruleForm.mobile,
          randomNum: this.randomNum,
          userType: 1,
          verificationImg: verificationImg
        }
        this.getHttpServices().getBaseService().post('sms/verification', params)
          .then(res => {
            this.$message.success('短信验证码已经发送')
            this.startTimer()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.success('请输入图形验证码')
      }

    },
    startTimer() {
      if (!this.timer) {
        this.timer = new countDownHelper(60000, 1000)
        this.timer.onCountDownListener = (timeInfo) => {
          this.second = timeInfo.second
        }
        this.timer.onFinishListener = () => {
          this.second = 0
          this.timer = undefined
        }
        this.timer.start()
      }
    },
    saveEvent() {
      if (!this.isShowInfo) {
        this.closeData()
        return
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeData() {
      const params = {
        paymentId: this.WxSetInfo.paymentId,
        paymentMerchantId: this.WxSetInfo.paymentMerchantId,
        paymentStatus: this.ruleForm.paymentStatus ? 1 : 2
      }
      this.getHttpServices().getUserService().post('api/v2/paySetUp/paymentStatus/update', params)
        .then(res => {
          this.$message.success('设置成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    submitData() {
      const params = {
        aliPayAppId: this.ruleForm.aliPayAppId,
        aliPayAppPrivateKey: this.ruleForm.aliPayAppPrivateKey,
        aliPayAppPublicKey: this.ruleForm.aliPayAppPublicKey,
        aliPayIpWhitelist: this.ruleForm.aliPayIpWhitelist,
        aliPayNotifyUrl: this.ruleForm.aliPayNotifyUrl,
        mobile: this.mobileShow,
        paymentId: this.WxSetInfo.paymentId,
        paymentMerchantId: this.WxSetInfo.paymentMerchantId,
        paymentOwn: this.ruleForm.paymentOwn ? 1 : 2,
        paymentStatus: this.ruleForm.paymentStatus ? 1 : 2,
        verificationCode: this.ruleForm.verificationCode
      }
      this.getHttpServices().getUserService().post('api/v2/paySetUp/ali/save', params)
        .then(res => {
          this.$message.success('设置成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }

  }

}
</script>
<style lang="less" scoped>
.single-import-box {
  margin-top: 30px;

  .upload-box {
    margin-top: 14px;
    height: 104px;
    position: relative;
  }

  .selected-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 104px;
  }

  .image-sample {
    position: absolute;
    top: 0;
    left: 200px;
    height: 104px;
  }

  .image-sample-1 {
    position: absolute;
    top: 0;
    left: 112px;
    height: 104px;
  }

  input {
    max-width: 400px;
  }

  .single-import-box > .ant-upload {
    width: 180px;
    height: 104px;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}

</style>